/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../dialogs'
import { AttributeParameterForm } from '../../AttributeParameterForm'

export const AttributeParameterDialogUpdate = ({
  currentProject,
  currentScenario,
  openDialog,
  setOpenDialog,
  parameters,
  parameter,
  actionUpdateDispatch
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.parameters.update.scenario')
    : currentProject
    ? t('attributes.parameters.update.project')
    : t('attributes.parameters.update.global')

  /**
   * Action received from the Parameter Form.
   * @see AttributeParameterForm
   *
   * @param {object} newParameter Parameter attribute object to update.
   * @param {string} newParameterId Parameter attribute Id to update.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newParameter, newParameterId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeParameterDialogUpdate.onDispatchAction()', {
      newParameter,
      newParameterId,
      currentProject,
      currentScenario,
      actionUpdateDispatch
    })

    if (actionUpdateDispatch) {
      dispatch(actionUpdateDispatch(newParameter, newParameterId, currentProject?.id, currentScenario?.id))
        .then((res) => {
          Logger.trace(
            LoggerTypes.CONTROLLER,
            'AttributeParameterDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).then()',
            {
              res
            }
          )
          if (res?.data?.isAxiosError) {
            enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
          } else if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(res)
          }
        })
        .catch((res) => {
          Logger.trace(
            LoggerTypes.WARN,
            'AttributeParameterDialogUpdate.onDispatchAction().dispatch(actionUpdateDispatch(...)).catch()',
            { res }
          )

          checkErrorResponse(res, enqueueSnackbar, t)

          if (res?.response?.data?.fields) {
            setErrors(res.response.data.fields)
          }
        })
    } else {
      Logger.trace(LoggerTypes.WARN, 'AttributeParameterDialogUpdate.onDispatchAction().catch()', {
        currentProject,
        currentScenario,
        actionUpdateDispatch
      })
    }
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeParameterDialogUpdate.render()', {
    currentProject,
    currentScenario,
    parameter
  })

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeParameterForm
        title={title}
        setOpenDialog={setOpenDialog}
        parameters={parameters}
        parameter={parameter}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeParameterDialogUpdate.displayName = 'AttributeParameterDialogUpdate'

AttributeParameterDialogUpdate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionUpdateDispatch: PropTypes.func.isRequired,
  parameters: PropTypes.arrayOf(PropTypes.object),
  parameter: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string
  }).isRequired
}

AttributeParameterDialogUpdate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  dispatchAction: () => {},
  actionUpdateDispatch: null,
  parameters: [],
  parameter: {
    id: null,
    name: '',
    description: ''
  }
}
